import { Autocomplete, useJsApiLoader } from "@react-google-maps/api";
import { useState } from "react";

type KycData = {
  photo: string;
  documentID: string;
  documentType: string;
  expirationDate: string;
  agentId: string;
  agentIdNumber: string;
  address: string;
};

// const PersonalFormInput = () => {
//   return (
//     <div>PersonalFormInput</div>
//   )
// }
// export default PersonalFormInput

export const PersonalFormInput = ({
  handleKycOnChange,
  kycData,
  loading,
  handleKycSubmit,
  previewUrl,
  file,
}: {
  user?: any;
  handleKycOnChange: (e: any) => void;
  kycData: KycData;
  loading: boolean;
  handleKycSubmit: any;
  previewUrl: any;
  file: any;
}) => {
  const [autoComplete, setAutoComplete] =
    useState<google.maps.places.Autocomplete | null>(null);

  const onLoad = (autocomplete: google.maps.places.Autocomplete) => {
    setAutoComplete(autocomplete);
  };

  const onPlaceChanged = () => {
    if (autoComplete !== null) {
      const place = autoComplete.getPlace();
      const address = place.formatted_address;

      if (address) {
        handleKycOnChange({
          target: {
            name: "address",
            value: address,
          },
        });
      }
    } else {
      console.log("Autocomplete is not loaded yet!");
    }
  };

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env["REACT_APP_GOOGLE_API_KEY"] || "",
    libraries: ["places"],
  });
  return (
    <div className="mb-4">
      <div className="row">
        <div className="col-md-6 col-12 mb-4">
          <label className="fw-bolder form-label text-capitalize">
            Identification Type
          </label>
          <select
            className="form-select rounded-pill py-3 px-4 fs-14 mb-3"
            value={kycData.documentType}
            onChange={handleKycOnChange}
            required
            name="documentType"
          >
            <option value="">Select</option>
            <option value="NATIONAL_ID">National ID</option>
            <option value="PASSPORT">International Passport</option>
            <option value="VOTERS_CARD">Voters Card</option>
            <option value="DRIVERS_LICENCE">Drivers license</option>
          </select>
        </div>
        <div className="col-md-6 col-12 mb-4">
          <label className="fw-bolder form-label text-capitalize">
            ID Number
          </label>
          <input
            type="text"
            className="form-control rounded-pill py-3 px-4 fs-14 mb-3"
            value={kycData.documentID}
            onChange={handleKycOnChange}
            required
            name="documentID"
            placeholder="Input ID Number"
          />
        </div>
      </div>

      <div className="row">
        <div className="col-md-6 col-12 mb-2">
          <label className="fw-bolder form-label text-capitalize">
            Expiry Date
          </label>
          <div className="input-group mb-3">
            <input
              type="date"
              className="form-control border-end-0 border-rounded-5 py-3 px-4 rounded-pill-start"
              value={kycData.expirationDate}
              onChange={handleKycOnChange}
              name="expirationDate"
              required
              id="expiryDate"
              min={
                new Date(new Date().getTime() + 86400000)
                  .toISOString()
                  .split("T")[0]
              }
            />
            <label
              className="input-group-text rounded-pill-end bg-transparent text-link text-decoration-none border-start-0 pe-4"
              htmlFor="expiryDate"
            >
              ID Expiry Date
            </label>
          </div>
        </div>
        <div className="col-md-6 col-12 mb-2">
          <label className="fw-bolder form-label text-capitalize">
            Choose ID
          </label>
          <div className="input-group ">
            <input
              type="file"
              className="form-control border-end-0 border-rounded-5 py-3 px-4 rounded-pill-start"
              placeholder="No file selected"
              id="personalID"
              name="photo"
              required
              onChange={handleKycOnChange}
            />
            <label
              className="input-group-text rounded-pill-end bg-transparent text-link text-decoration-none border-start-0 pe-4"
              htmlFor="personalID"
            >
              Upload ID
            </label>
          </div>
          <p className="mb-2 ml-2 text-danger fs-10">file size - max 5mb</p>
          {/* preview*/}
          {previewUrl && (
            <div>
              {file.type === "image/jpeg" ? (
                // Render image preview if the file is an image
                <img
                  src={previewUrl}
                  alt="File Preview"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "200px",
                  }}
                />
              ) : file.type === "application/pdf" ? (
                // Render PDF preview using <embed> or <iframe> if the file is a PDF
                // <embed
                //   src={URL.createObjectURL(
                //     new Blob([previewUrl], {type: 'application/pdf'})
                //   )}
                //   type='application/pdf'
                //   width='100%'
                //   height='400px'
                // />
                <iframe
                  src={previewUrl}
                  width="100%"
                  height="200px"
                  style={{ border: "1px solid #ccc" }}
                  title="PDF Preview"
                />
              ) : (
                // Fallback message if the file type is not supported for preview
                <p>Preview not available for this file type</p>
              )}
            </div>
          )}
          {/* testing */}
        </div>
        <div className="col-md-6 col-12 mb-4">
          <label className="fw-bolder form-label text-capitalize">
            Location
          </label>
          {isLoaded ? (
            <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
              <input
                type="text"
                className="form-control rounded-pill py-3 px-4 fs-14 mb-3"
                value={kycData.address}
                onChange={handleKycOnChange}
                required
                name="address"
                placeholder="Input your address"
              />
            </Autocomplete>
          ) : (
            <input
              type="text"
              className="form-control rounded-pill py-3 px-4 fs-14 mb-3"
              value={kycData.address}
              onChange={handleKycOnChange}
              required
              name="address"
              placeholder="Input your address"
            />
          )}
        </div>
      </div>
      <div className="mb-2">
        <button
          type="submit"
          className="btn btn-primary rounded-pill py-3 px-5 fw-bold fs-14 col-12 col-md-4 mb-3"
          disabled={loading}
          onClick={handleKycSubmit}
        >
          {loading ? (
            <span
              className="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          ) : (
            "Submit Personal KYC"
          )}
        </button>
      </div>
    </div>
  );
};
